import {
  Box,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  PaginationTable,
  RowTableCell,
} from '../../../../common/components';

/**
 * Renderiza la tabla de contratos archivados.
 * @param {Object} props - Props del componente.
 * @param {Array<Object>} props.rows - Filas del reporte.
 * @param {Object} props.pagination - Datos de paginación.
 * @param {Function} props.onPageChange - Handler de página.
 * @param {Function} props.onRowsPerPageChange - Handler de items por página.
 * @returns {JSX.Element} Tabla de bajas.
 */
const ArchivedContractsTable = ({
  rows,
  pagination,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const buildTruncatedText = (value, maxWidth = 220, titleValue) => (
    <Typography
      variant="body2"
      title={titleValue ?? value}
      sx={{
        maxWidth,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {value}
    </Typography>
  );

  if (!rows.length) {
    return (
      <GeneralTableBox>
        <Typography variant="body1" color="text.secondary">
          No se encontraron registros que coincidan con los filtros seleccionados.
        </Typography>
      </GeneralTableBox>
    );
  }

  return (
    <Box>
      <GeneralTableBox>
        <Table size="small">
          <TableHead>
            <TableRow>
              <HeadTableCell sx={{ maxWidth: 140 }}>Num. contrato</HeadTableCell>
              <HeadTableCell sx={{ maxWidth: 300 }}>Suscriptores</HeadTableCell>
              <HeadTableCell sx={{ maxWidth: 240 }}>Motivo baja</HeadTableCell>
              <HeadTableCell sx={{ maxWidth: 140 }}>Fecha baja</HeadTableCell>
              <HeadTableCell sx={{ maxWidth: 260 }}>Contacto</HeadTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow
                key={`${row.contract_uuid || 'contract'}-${row.contract_number || index}`}
                hover
              >
                <RowTableCell sx={{ maxWidth: 140 }}>{row.contract_number || '-'}</RowTableCell>
                <RowTableCell sx={{ maxWidth: 320 }}>
                  {buildTruncatedText(row.subscriber_names || 'Sin suscriptor', 320)}
                </RowTableCell>
                <RowTableCell sx={{ maxWidth: 240 }}>
                  {buildTruncatedText(
                    row.release_reason || 'Sin motivo',
                    240,
                    row.release_reason_obs || row.release_reason || 'Sin motivo'
                  )}
                </RowTableCell>
                <RowTableCell sx={{ maxWidth: 140 }}>{row.deleted_at || '-'}</RowTableCell>
                <RowTableCell sx={{ maxWidth: 260 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    {buildTruncatedText(row.contact_email || '-', 260)}
                    {buildTruncatedText(row.contact_phone || '-', 260)}
                  </Box>
                </RowTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </GeneralTableBox>
      {pagination?.pages > 1 && (
        <PaginationTable
          totalPages={pagination.pages}
          totalCount={pagination.total}
          page={pagination.page}
          onPageChange={onPageChange}
          rowsPerPage={pagination.rowsPerPage}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      )}
    </Box>
  );
};

export default ArchivedContractsTable;
